var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50994 19.207C6.31994 19.207 6.12994 19.137 5.97994 18.987L0.969941 13.977C0.679941 13.687 0.679941 13.207 0.969941 12.917C1.25994 12.627 1.73994 12.627 2.02994 12.917L7.03994 17.927C7.32994 18.217 7.32994 18.697 7.03994 18.987C6.88994 19.127 6.69994 19.207 6.50994 19.207Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51001 19.207C6.10001 19.207 5.76001 18.867 5.76001 18.457V1.45703C5.76001 1.04703 6.10001 0.707031 6.51001 0.707031C6.92001 0.707031 7.26001 1.04703 7.26001 1.45703V18.457C7.26001 18.867 6.92001 19.207 6.51001 19.207Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5099 7.21697C17.3199 7.21697 17.1299 7.14697 16.9799 6.99697L11.9699 1.98697C11.6799 1.69697 11.6799 1.21697 11.9699 0.926973C12.2599 0.636973 12.7399 0.636973 13.0299 0.926973L18.0399 5.93697C18.3299 6.22697 18.3299 6.70697 18.0399 6.99697C17.8899 7.14697 17.6999 7.21697 17.5099 7.21697Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.49 19.207C12.08 19.207 11.74 18.867 11.74 18.457V1.45703C11.74 1.04703 12.08 0.707031 12.49 0.707031C12.9 0.707031 13.24 1.04703 13.24 1.45703V18.457C13.24 18.867 12.91 19.207 12.49 19.207Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortTable);
export default __webpack_public_path__ + "static/media/sort-table.80b072b33341cdde52076d5457b51d66.svg";
export { ForwardRef as ReactComponent };